import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const CreateMAMRequest = {
  create: async (payload) => {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return AxiosInstance.post("/request-mam-account-create", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export default CreateMAMRequest;